import { LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT } from "./actionTypes";

import * as AuthService from "../../services/auth-service";

export const userLogin = (username, password) => (dispatch) => {
    return AuthService.login(username, password)
        .then((response) => {
            dispatch({
                type: LOGIN_SUCCESS,
                payload: { user: response },
            });
            return JSON.stringify(response);
        })
        .catch((error) => {
            let errorMessage = error.toString();
            if (error?.response?.data?.non_field_errors) {
                // django response if login/pass incorrect
                errorMessage = error.response.data.non_field_errors[0];
            }
            if (error?.response?.data?.error) {
                // django response in case of wrong subdomain
                errorMessage = error.response.data.error;
            }
            let errorCode = false;
            if (error?.response?.status) {
                // .response doesn't always exist, so always double check before trying to use anything passed in the response.
                errorCode = error.response.status;
            }
            dispatch({
                type: LOGIN_FAIL,
                payload: { errorMessage: errorMessage, errorCode: errorCode },
            });
            throw { errorMessage: errorMessage, errorCode: errorCode };
        });
};

// export const userRegister = (username, password) => (dispatch) => {
//   return AuthService.register(username,password)
//   .then((response) => {
//     dispatch({
//       type: REGISTER_SUCCESS,
//       payload:
//     })
//   })
// }

export const userLogout = () => (dispatch) => {
    localStorage.removeItem("user");
    dispatch({
        type: LOGOUT,
    });
};
